import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveRadiusComponent } from '../../shared/components/SaveRadiusComponent';

export interface CreateRadiusPageProps {}

const CreateRadiusPage: React.FC<CreateRadiusPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_radius);

  return <SaveRadiusComponent title="Crear Radius" />;
};

export default CreateRadiusPage;
